/**
 * Quién puede usar el chat del Ulture Assistant.
 *
 * ÚNICA fuente de verdad del lado cliente; la lista del backend
 * (supabase/functions/ipm-ai-assistant/index.ts) debe coincidir. Hoy: admin y
 * manager. Los peritos veían la pestaña «Asistente» y CADA mensaje moría en un
 * 403 — mejor no enseñar una puerta que no abre.
 */
export const ASSISTANT_ROLES = ["admin", "manager"] as const;

export function canUseAssistant(role: string | null | undefined): boolean {
  return !!role && (ASSISTANT_ROLES as readonly string[]).includes(role);
}
